import classNames from 'classnames';

const Item = ({handleSelectInputGroup, item}: IInputGroupItemProps) => {
  return (
    <>
      <div onClick={() => handleSelectInputGroup(item.id)}>
        <div
          className={classNames(
            ' bg-white shadow-lg p-3 rounded-md ',
            item.isSelected && 'border border-primary',
          )}
        >
          <img src={item.icon} alt="input group" />
        </div>
        <p className="text-center text-xs mt-2">{item.title}</p>
      </div>
    </>
  );
};

export default Item;
